module.exports = __webpack_public_path__ + "img/mastercard-black.2252f901.png";